import { useEffect, useState } from "react";
import { Link } from "react-router-dom";
import { ArrowLeft, Building2, Save, Loader2 } from "lucide-react";
import { toast } from "sonner";
import api from "../lib/api";
import { Button } from "../components/ui/button";

const FIELDS = [
    ["name", "Firmenname *"], ["owner", "Inhaber / Vertreten durch"],
    ["street", "Straße & Hausnummer"], ["zip", "PLZ"], ["city", "Ort"],
    ["country", "Land"], ["phone", "Telefon"], ["email", "E-Mail"],
    ["web", "Webseite"], ["ust_id", "USt-IdNr."],
];

// Jul-2026 (User-Wunsch) — Betreiberdaten zentral pflegen: speisen Impressum
// und die Signatur aller System-E-Mails.
export default function AdminOperatorPage() {
    const [form, setForm] = useState(null);
    const [busy, setBusy] = useState(false);

    useEffect(() => {
        api.get("/platform/operator").then((r) => setForm(r.data)).catch(() => toast.error("Laden fehlgeschlagen"));
    }, []);

    const save = async () => {
        if (!form?.name?.trim()) { toast.error("Firmenname ist Pflicht"); return; }
        setBusy(true);
        try {
            await api.put("/admin/platform/operator", form);
            toast.success("Betreiberdaten gespeichert — Impressum & E-Mail-Signatur aktualisiert");
        } catch (e) { toast.error(e.response?.data?.detail || "Speichern fehlgeschlagen"); }
        setBusy(false);
    };

    return (
        <div className="max-w-2xl mx-auto px-4 py-8" data-testid="admin-operator-page">
            <Link to="/admin" className="inline-flex items-center gap-1 text-sm text-gray-600 hover:text-[#111827] mb-4">
                <ArrowLeft className="w-4 h-4" /> Admin-Übersicht
            </Link>
            <div className="flex items-center gap-2 mb-1">
                <Building2 className="w-6 h-6 text-[#FF8300]" />
                <h1 className="text-2xl font-black text-[#111827]">Betreiberdaten</h1>
            </div>
            <p className="text-sm text-gray-500 mb-6">
                Diese Daten erscheinen im öffentlichen <Link to="/impressum" className="underline">Impressum</Link> und
                in der Signatur aller System-E-Mails der Plattform.
            </p>
            {!form ? (
                <div className="text-center py-10 text-gray-400"><Loader2 className="w-5 h-5 animate-spin inline" /></div>
            ) : (
                <div className="bg-white border-2 border-gray-200 rounded-sm p-5 space-y-4">
                    <div className="grid grid-cols-1 sm:grid-cols-2 gap-4">
                        {FIELDS.map(([key, label]) => (
                            <label key={key} className={key === "street" || key === "name" ? "sm:col-span-2" : ""}>
                                <span className="text-xs font-bold text-gray-500 uppercase tracking-wider">{label}</span>
                                <input
                                    value={form[key] || ""}
                                    onChange={(e) => setForm((f) => ({ ...f, [key]: e.target.value }))}
                                    className="mt-1 w-full h-10 rounded-sm border-2 border-gray-300 px-3 text-sm focus:outline-none focus:border-[#111827]"
                                    data-testid={`operator-field-${key}`}
                                />
                            </label>
                        ))}
                    </div>
                    <Button onClick={save} disabled={busy} className="bg-[#111827] text-[#FFCC00] rounded-sm font-black hover:bg-black" data-testid="operator-save-btn">
                        {busy ? <Loader2 className="w-4 h-4 animate-spin mr-2" /> : <Save className="w-4 h-4 mr-2" />} Speichern
                    </Button>
                </div>
            )}
        </div>
    );
}
